import api from "../lib/api";

export const listBlogs = async ({ category, limit = 50, skip = 0 } = {}) => {
  const params = { limit, skip };
  if (category && category !== "all") params.category = category;
  const { data } = await api.get("/blogs", { params });
  return data;
};

export const getBlog = async (slugOrId) => {
  const { data } = await api.get(`/blog/${slugOrId}`);
  return data;
};

export const listAdminBlogs = async () => {
  const { data } = await api.get("/admin/blogs");
  return data;
};

export const getAdminBlog = async (slugOrId) => {
  const { data } = await api.get(`/admin/blogs/${slugOrId}`);
  return data;
};

export const createBlog = async (payload) => {
  const { data } = await api.post("/admin/blogs", payload);
  return data;
};

export const updateBlog = async (id, payload) => {
  const { data } = await api.put(`/admin/blogs/${id}`, payload);
  return data;
};

export const deleteBlog = async (id) => {
  const { data } = await api.delete(`/admin/blogs/${id}`);
  return data;
};

export const collectBlogCategories = (blogs) => {
  const seen = new Set();
  const categories = [];
  blogs.forEach((blog) => {
    const category = String(blog.category || "").trim();
    const key = category.toLowerCase();
    if (category && !seen.has(key)) {
      seen.add(key);
      categories.push(category);
    }
  });
  return categories.sort((a, b) => a.localeCompare(b));
};
